'use es6';

import { Record } from 'immutable';
import { AudienceSources, AudienceSourcesToAudienceType, Networks } from 'AdsUI/lib/Constants';
export const TargetingFacetTypes = {
  AUDIENCE_MATCHING_SEGMENTS: 'AUDIENCE_MATCHING_SEGMENTS',
  DYNAMIC_SEGMENTS: 'DYNAMIC_SEGMENTS'
};
const INVALID_LINKEDIN_ERRORS = ['FAILED', 'EXPIRED', 'ARCHIVED'];
const INVALID_ADWORDS_ERROR = 'Audience is not active for user';
export default class AudienceNetworkStateRecord extends Record({
  adNetwork: null,
  approximateSize: null,
  audienceSource: null,
  description: null,
  errorCode: null,
  errorMessage: null,
  id: null,
  lookalikeTargetingCountries: null,
  name: null,
  linkedInAdTargetingFacet: null
}) {
  get type() {
    return AudienceSourcesToAudienceType[this.audienceSource];
  }

  get linkedInTargetingFacetType() {
    switch (this.audienceSource) {
      case AudienceSources.HUBSPOT_CONTACT_LIST:
      case AudienceSources.HUBSPOT_COMPANY_LIST:
        {
          return TargetingFacetTypes.AUDIENCE_MATCHING_SEGMENTS;
        }

      case AudienceSources.NETWORK_PIXEL:
        {
          return TargetingFacetTypes.DYNAMIC_SEGMENTS;
        }

      default:
        return this.linkedInAdTargetingFacet;
    }
  }

  get isValidForAdCreation() {
    switch (this.adNetwork) {
      case Networks.FACEBOOK:
        {
          return this.errorCode < 400;
        }

      case Networks.LINKEDIN:
        {
          return !INVALID_LINKEDIN_ERRORS.includes(this.errorMessage);
        }

      case Networks.ADWORDS:
        {
          return this.errorMessage !== INVALID_ADWORDS_ERROR;
        }

      default:
        {
          return true; // optimism
        }
    }
  }

}